import React from "react";
import { CSVLink } from "react-csv";
import { changeDateFormat } from "../../utils";
import export2excel from "../../assets/images/export2excel.svg";
import { AcpService } from "../../service/ACPService";
import { replaceUnderscoreWithSpace } from "../ACP/utils";
export const ExportData = ({ allData, selectedRows, headers, filename, disabled = false }) => {
  let updatedData = {};
  let selectedUpdatedData = {};

  const formattedAllData =
    allData !== undefined &&
    allData?.map((data) => {
      updatedData = {
        ...data,
      };

      if (
        data &&
        (data["Slack"] !== undefined ||
          data["PmName"] !== undefined ||
          data["EndDate"] !== undefined ||
          data["Assignee"] !== undefined ||
          data["Duration"] !== undefined ||
          data["TaskName"] !== undefined ||
          data["StartDate"] !== undefined ||
          data["ProjectName"] !== undefined ||
          data["AWMProjectID"] !== undefined ||
          data["BufferToWork"] !== undefined ||
          data["NewStartDate"] !== undefined ||
          data["ProjectState"] !== undefined ||
          data["AwRedinessDate"] !== undefined ||
          data["RemainingBuffer"] !== undefined ||
          data["EstimatedOfPOAs"] !== undefined ||
          data["AWMRemainingBuffer"] !== undefined ||
          data["EstimatedAWPrinter"] !== undefined ||
          data["AWMTaskRemainingWork"] !== undefined ||
          data["ArtworkReadinessDate"] !== undefined ||
          data["PM"] !== undefined ||
          data["AWMTaskRemainingBuffer"] !== undefined) ||
          data["DSBP_PMP_ArtworkDate"] !== undefined ||
          data["DSBP_PMP_FPC_SOS"] !== undefined ||
          data["DSBP_PMP_FPC_SOSDate"] !== undefined ||
          data["DSBP_PMP_FPC_SOS"] !== undefined ||
          data["POA_Release_Date"] !== undefined ||
          data["RTA_Color_Seperation_Date"] !== undefined ||
         //planning
         data["Projected_FA_FullKit_Date"] !== undefined ||
         data["Projected FA FullKit Date"] !== undefined ||
         data["DSBP_PMP_ArtworkDate"] !== undefined 

      ) {
        if (filename === "Task_List") {
          updatedData["Buffer"] = data["RemainingBuffer"];
          updatedData["New Start Date"] = changeDateFormat(data["NewStartDate"]);
          updatedData["Owner"] = data["PM"];
        } else if (filename === "Project_List") {
          updatedData["Buffer"] = data["AWMRemainingBuffer"];
          updatedData["New Readiness"] = changeDateFormat(data["NewStartDate"]);
          updatedData["Owner"] = data["PM"];
        }

        if (filename !== "Task_List" && filename !== "Project_List") {
          updatedData["Buffer"] = data["AWMTaskRemainingBuffer"];
          updatedData["Buffer:Work"] = data["BufferToWork"];
          updatedData["Owner"] = data["Owner"] ? data["Owner"] : data["Assignee"];
        }

        updatedData["Slack"] = data["Slack"];
        updatedData["PM Name"] = data["PmName"]?.name ? data["PmName"]?.name : data["PmName"];
        updatedData["Buffer:Work"] = data["BufferToWork"];
        updatedData["Task Name"] = data["TaskName"];
        updatedData["Task Duration"] = data["Duration"];
        updatedData["Project ID"] = data["AWMProjectID"];
        updatedData["Project Name"] = data["ProjectName"];
        updatedData["#of POAs"] = data["EstimatedOfPOAs"];
        updatedData["Work"] = data["AWMTaskRemainingWork"];
        updatedData["Work"] = data["AWMTaskRemainingWork"];
        updatedData["Project State"] = data["ProjectState"];
        updatedData["End Date"] = AcpService.checkIfValidDate(data["EndDate"])
          ? data["EndDate"]
          : changeDateFormat(data["EndDate"]);
        updatedData["Artwork Readiness"] = AcpService.checkIfValidDate(data["ArtworkReadinessDate"])
          ? data["ArtworkReadinessDate"]
          : data["ArtworkReadinessDate"];
        updatedData["Start Date"] = AcpService.checkIfValidDate(data["StartDate"])
          ? data["StartDate"]
          : changeDateFormat(data["StartDate"]);
        updatedData["Current Start Date"] = AcpService.checkIfValidDate(data["StartDate"])
          ? data["StartDate"]
          : changeDateFormat(data["StartDate"]);
        updatedData["AW Rediness Date"] = AcpService.checkIfValidDate(data["AwRedinessDate"])
          ? data["AwRedinessDate"]
          : changeDateFormat(data["AwRedinessDate"]);
        updatedData["Art@Printer Date"] = AcpService.checkIfValidDate(data["EstimatedAWPrinter"])
          ? data["EstimatedAWPrinter"]
          : changeDateFormat(data["EstimatedAWPrinter"]);

        updatedData["DSBP_PMP_ArtworkDate"] = AcpService.checkIfValidDate(data["DSBP_PMP_ArtworkDate"])
          ? data["DSBP_PMP_ArtworkDate"]
          : changeDateFormat(data["DSBP_PMP_ArtworkDate"]);
        updatedData["DSBP_PMP_FPC_SOS"] = AcpService.checkIfValidDate(data["DSBP_PMP_FPC_SOS"])
          ? data["DSBP_PMP_FPC_SOS"]
          : changeDateFormat(data["DSBP_PMP_FPC_SOS"]);
        updatedData["DSBP_PMP_FPC_SOSDate"] = AcpService.checkIfValidDate(data["DSBP_PMP_FPC_SOSDate"])
          ? data["DSBP_PMP_FPC_SOSDate"]
          : changeDateFormat(data["DSBP_PMP_FPC_SOSDate"]);
          updatedData["DSBP_PMP_FPC_SOS"] = AcpService.checkIfValidDate(data["DSBP_PMP_FPC_SOS"])
          ? data["DSBP_PMP_FPC_SOS"]
          : changeDateFormat(data["DSBP_PMP_FPC_SOS"]);
        updatedData["POA_Release_Date"] = AcpService.checkIfValidDate(data["POA_Release_Date"])
          ? data["POA_Release_Date"]
          : changeDateFormat(data["POA_Release_Date"]);
        updatedData["RTA_Color_Seperation_Date"] = AcpService.checkIfValidDate(data["RTA_Color_Seperation_Date"])
          ? data["RTA_Color_Seperation_Date"]
          : changeDateFormat(data["RTA_Color_Seperation_Date"]);

          //planning
          updatedData["Projected_FA_FullKit_Date"] = AcpService.checkIfValidDate(data["Projected_FA_FullKit_Date"])
          ? data["Projected_FA_FullKit_Date"]
          : changeDateFormat(data["Projected_FA_FullKit_Date"]);

          updatedData["Projected FA FullKit Date"] = AcpService.checkIfValidDate(data["Projected_FA_FullKit_Date"])
          ? data["Projected_FA_FullKit_Date"]
          : changeDateFormat(data["Projected_FA_FullKit_Date"]);

          updatedData["DSBP_PMP_ArtworkDate"] = AcpService.checkIfValidDate(data["DSBP_PMP_ArtworkDate"])
          ? data["DSBP_PMP_ArtworkDate"]
          : changeDateFormat(data["DSBP_PMP_ArtworkDate"]);

      }

      return updatedData;
    });
  const formattedSelectedRows =
    selectedRows !== undefined &&
    selectedRows?.map((data) => {
      selectedUpdatedData = {
        ...data,
      };

      if (
        data &&
        (data["Slack"] !== undefined ||
          data["PmName"] !== undefined ||
          data["EndDate"] !== undefined ||
          data["Assignee"] !== undefined ||
          data["Duration"] !== undefined ||
          data["TaskName"] !== undefined ||
          data["StartDate"] !== undefined ||
          data["ProjectID"] !== undefined ||
          data["ProjectName"] !== undefined ||
          data["TaskDuration"] !== undefined ||
          data["AWMProjectID"] !== undefined ||
          data["BufferToWork"] !== undefined ||
          data["NewStartDate"] !== undefined ||
          data["ProjectState"] !== undefined ||
          data["AwRedinessDate"] !== undefined ||
          data["RemainingBuffer"] !== undefined ||
          data["EstimatedOfPOAs"] !== undefined ||
          data["EstimatedAWPrinter"] !== undefined ||
          data["AWMRemainingBuffer"] !== undefined ||
          data["AWMTaskRemainingWork"] !== undefined ||
          data["ArtworkReadinessDate"] !== undefined ||
          data["AWMTaskRemainingBuffer"] !== undefined) ||
          data["DSBP_PMP_ArtworkDate"] !== undefined ||
          data["DSBP_PMP_FPC_SOS"] !== undefined ||
          data["DSBP_PMP_FPC_SOSDate"] !== undefined ||
          data["DSBP_PMP_FPC_SOS"] !== undefined ||
          data["POA_Release_Date"] !== undefined ||
          data["RTA_Color_Seperation_Date"] !== undefined ||
          data["Projected_FA_FullKit_Date"] !== undefined ||
          data["DSBP_PMP_ArtworkDate"] !== undefined ||
          data["AWM_CICNeeded"] !== undefined 
      ) {
        if (filename === "Task_List") {
          selectedUpdatedData["Buffer"] = data["RemainingBuffer"];
          selectedUpdatedData["New Start Date"] = changeDateFormat(data["NewStartDate"]);
          selectedUpdatedData["Owner"] = data["PM"];
        } else if (filename === "Project_List") {
          selectedUpdatedData["Buffer"] = data["AWMRemainingBuffer"];
          selectedUpdatedData["New Readiness"] = changeDateFormat(data["NewStartDate"]);
          selectedUpdatedData["Owner"] = data["PM"];
        }

        if (filename !== "Task_List" && filename !== "Project_List") {
          selectedUpdatedData["Buffer"] = data["AWMTaskRemainingBuffer"];
          selectedUpdatedData["Owner"] = data["Owner"] ? data["Owner"] : data["Assignee"];
        }

        selectedUpdatedData["Slack"] = data["Slack"];
        selectedUpdatedData["PM Name"] = data["PmName"]?.name ? data["PmName"]?.name : data["PmName"];
        selectedUpdatedData["Buffer:Work"] = data["BufferToWork"];
        selectedUpdatedData["Task Name"] = data["TaskName"];
        selectedUpdatedData["Project ID"] = data["ProjectID"];
        selectedUpdatedData["Task Duration"] = data["Duration"];
        selectedUpdatedData["Project ID"] = data["AWMProjectID"];
        selectedUpdatedData["Project Name"] = data["ProjectName"];
        selectedUpdatedData["#of POAs"] = data["EstimatedOfPOAs"];
        selectedUpdatedData["Buffer:Work"] = data["BufferToWork"];
        selectedUpdatedData["Work"] = data["AWMTaskRemainingWork"];
        selectedUpdatedData["Work"] = data["AWMTaskRemainingWork"];
        selectedUpdatedData["Project State"] = data["ProjectState"];
        selectedUpdatedData["Task Duration"] = data["TaskDuration"];
        selectedUpdatedData["AW Rediness Date"] = data["AwRedinessDate"];
        selectedUpdatedData["End Date"] = AcpService.checkIfValidDate(data["EndDate"])
          ? data["EndDate"]
          : changeDateFormat(data["EndDate"]);
        selectedUpdatedData["Artwork Readiness"] = AcpService.checkIfValidDate(
          data["ArtworkReadinessDate"]
        )
          ? data["ArtworkReadinessDate"]
          : changeDateFormat(data["ArtworkReadinessDate"]);
        updatedData["Start Date"] = AcpService.checkIfValidDate(data["StartDate"])
          ? data["StartDate"]
          : changeDateFormat(data["StartDate"]);
        selectedUpdatedData["Current Start Date"] = AcpService.checkIfValidDate(data["StartDate"])
          ? data["StartDate"]
          : changeDateFormat(data["StartDate"]);
        selectedUpdatedData["Art@Printer Date"] = AcpService.checkIfValidDate(
          data["EstimatedAWPrinter"]
        )
          ? data["EstimatedAWPrinter"]
          : changeDateFormat(data["EstimatedAWPrinter"]);
        selectedUpdatedData["AWM CICNeeded"] = data["AWM_CICNeeded"];
        selectedUpdatedData["Projected FA FullKit Date"] = AcpService.checkIfValidDate(data["Projected_FA_FullKit_Date"])
        ? data["Projected_FA_FullKit_Date"]
        : changeDateFormat(data["Projected_FA_FullKit_Date"]);  


        selectedUpdatedData["DSBP_PMP_ArtworkDate"] = AcpService.checkIfValidDate(data["DSBP_PMP_ArtworkDate"])
          ? data["DSBP_PMP_ArtworkDate"]
          : changeDateFormat(data["DSBP_PMP_ArtworkDate"]);
        selectedUpdatedData["DSBP_PMP_FPC_SOS"] = AcpService.checkIfValidDate(data["DSBP_PMP_FPC_SOS"])
          ? data["DSBP_PMP_FPC_SOS"]
          : changeDateFormat(data["DSBP_PMP_FPC_SOS"]);
        selectedUpdatedData["DSBP_PMP_FPC_SOSDate"] = AcpService.checkIfValidDate(data["DSBP_PMP_FPC_SOSDate"])
          ? data["DSBP_PMP_FPC_SOSDate"]
          : changeDateFormat(data["DSBP_PMP_FPC_SOSDate"]);

          selectedUpdatedData["DSBP_PMP_FPC_SOS"] = AcpService.checkIfValidDate(data["DSBP_PMP_FPC_SOS"])
          ? data["DSBP_PMP_FPC_SOS"]
          : changeDateFormat(data["DSBP_PMP_FPC_SOS"]);

        selectedUpdatedData["POA_Release_Date"] = AcpService.checkIfValidDate(data["POA_Release_Date"])
          ? data["POA_Release_Date"]
          : changeDateFormat(data["POA_Release_Date"]);
        selectedUpdatedData["RTA_Color_Seperation_Date"] = AcpService.checkIfValidDate(data["RTA_Color_Seperation_Date"])
          ? data["RTA_Color_Seperation_Date"]
          : changeDateFormat(data["RTA_Color_Seperation_Date"]);

          //planning
        selectedUpdatedData["Projected_FA_FullKit_Date"] = AcpService.checkIfValidDate(data["Projected_FA_FullKit_Date"])
          ? data["Projected_FA_FullKit_Date"]
          : changeDateFormat(data["Projected_FA_FullKit_Date"]);
        selectedUpdatedData["DSBP_PMP_ArtworkDate"] = AcpService.checkIfValidDate(data["DSBP_PMP_ArtworkDate"])
          ? data["DSBP_PMP_ArtworkDate"]
          : changeDateFormat(data["DSBP_PMP_ArtworkDate"]);
      }

      return selectedUpdatedData;
    });
    const underscoreFormatedData=formattedAllData?.map((obj) => {
      const newObj={};
      for (const key in obj){
        const newKey=replaceUnderscoreWithSpace(key);
        newObj[newKey]=obj[key];
      }
      return newObj;

    });

  const modifiedHeaders = headers?.map((str) => {
    if (
      str?.startsWith("Artwork_") ||
      str?.startsWith("Project_region") ||
      str?.startsWith("Project_Scale")
    ) {
      return str?.substring(8); // Remove the first 8 characters ("Artwork_")
    } else {
      return str; // Keep the original string
    }
  });

  const newFormattedHeaderValues = modifiedHeaders?.map((header) =>
    header === "ProjectID"
      ? "Project ID"
      : header === "AWMProjectID"
      ? "Project ID"
      : header === "ProjectName"
      ? "Project Name"
      : header === "PmName"
      ? "PM Name"
      : header === "AwRedinessDate"
      ? "AW Rediness Date"
      : header === "Slack"
      ? "Slack"
      : header === "StartDate"
      ? filename === "Task_List" || filename === "Project_List"
        ? "Current Start Date"
        : "Start Date"
      : header === "BufferToWork"
      ? "Buffer:Work"
      : header === "PM"
      ? "Owner"
      : header === "TaskName"
      ? "Task Name"
      : header === "RemainingBuffer"
      ? "Buffer"
      : header === "ProjectState"
      ? "Project State"
      : header === "EstimatedOfPOAs"
      ? "#of POAs"
      : header === "ArtworkReadinessDate"
      ? "Artwork Readiness"
      : header === "AWMRemainingBuffer"
      ? filename === "Project_List"
        ? "Buffer"
        : "AWMRemainingBuffer"
      : header === "NewStartDate" && filename === "Project_List"
      ? "New Readiness"
      : header === "EstimatedAWPrinter" &&
        !(filename === "Task_List" || filename === "Project_List")
      ? "Art@Printer Date"
      : header === "Art@PrinterDate" && !(filename === "Task_List" || filename === "Project_List")
      ? "Art@Printer Date"
      : header === "Duration" && !(filename === "Task_List" || filename === "Project_List")
      ? "Task Duration"
      : header === "TaskDuration" && !(filename === "Task_List" || filename === "Project_List")
      ? "Task Duration"
      : header === "Assignee" && !(filename === "Task_List" || filename === "Project_List")
      ? "Owner"
      : header
  );
  const removeheaderUnderscore=newFormattedHeaderValues.map(item=>replaceUnderscoreWithSpace(item))

  if (!selectedRows || selectedRows.length === 0) {
    if (allData !== null && allData !== undefined) {
      const csvReport = {
        data: underscoreFormatedData.map((row) => {
          const newRow = { ...row };
          if (newRow.hasOwnProperty("ProjectID")) {
            newRow["Project ID"] = newRow["ProjectID"];
          } else if (newRow.hasOwnProperty("AWMProjectID")) {
            newRow["Project ID"] = newRow["AWMProjectID"];
          }
          return newRow;
        }),
        headers: removeheaderUnderscore,
        filename: filename ? `${filename}.csv` : "Project_Records.csv",
      };
      return <>{allData !== null && allData !== undefined && csvTag(csvReport, disabled)}</>;
    }
  } else if (selectedRows?.length > 0) {
    //Replace underscore with space to column name to show filtered data for export
    const underscoreFormatedFilterData = formattedSelectedRows?.map((obj) => {
      const newObj={};
      for (const key in obj){
        const newKey=replaceUnderscoreWithSpace(key);
        newObj[newKey]=obj[key];
      }
      return newObj;
    });
    const csvReport = {
      data: underscoreFormatedFilterData?.map((row) => {  
        const newRow = { ...row };
        if (newRow?.hasOwnProperty("ProjectID")) {
          newRow["Project ID"] = newRow["ProjectID"];
        } else if (newRow?.hasOwnProperty("AWMProjectID")) {
          newRow["Project ID"] = newRow["AWMProjectID"];
        }
        return newRow;
      }),
      headers: newFormattedHeaderValues,
      filename: filename ? `${filename}_Selected_Rows.csv` : "Selected_Rows.csv",
    };
    return <>{csvTag(csvReport, disabled)}</>;
  }
};

const csvTag = (data, disabled) => {
  return (
    <CSVLink {...data}>
      <img src={export2excel} alt="Export to csv" disabled={disabled} />
    </CSVLink>
  );
};

export default ExportData;